

export interface PassordOptions {
    requiredLength: 0,
    requiredUniqueChars: 0,
    requireNonAlphanumeric: true,
    requireLowercase: true,
    requireUppercase: true,
    requireDigit: true
  }

export const passwordValidation = (password: string, passwordOptions: PassordOptions) => {
    if (password.length < passwordOptions.requiredLength) {
        return `Şifre en az ${passwordOptions.requiredLength} karakter olmalıdır.`
    }
    else if (new Set(password).size < passwordOptions.requiredUniqueChars) {
        return `Şifre en az ${passwordOptions.requiredUniqueChars} farklı karakter içermelidir.`
    }
    else if (passwordOptions.requireNonAlphanumeric && !/[^a-zA-Z0-9]/.test(password)) {
        return `Şifre en az bir alfasayısal olmayan karakter içermelidir`
    }
    else if (passwordOptions.requireLowercase && !/[a-z]/.test(password)) {
        return `Şifre en az bir küçük harf içermelidir.`
    }
    else if (passwordOptions.requireUppercase && !/[A-Z]/.test(password)) {
        return `Şifre en az bir rakam içermelidir.`
    }
    else if (passwordOptions.requireDigit && !/\d/.test(password)) {
        return `Şifre en az bir büyük harf içermelidir.`
    }
}